import type { PaginationSetupData } from 'mmfintech-commons/types'
import { MMPagination as LibraryPagination } from 'mmfintech-portal-commons'

interface CustomProps {
  totalPages: number
  currentPage: number
  setCurrentPage: (data: PaginationSetupData) => void
  className?: string
  sort?: string
}

const MMPagination = (props: CustomProps) => {
  const { setCurrentPage, sort, ...rest } = props

  function onPageChange(page: number) {
    setCurrentPage({ page, sort })
  }

  return (
    <LibraryPagination
      minPagesVisible={2}
      marginPagesDisplayed={2}
      showPageLabel={true}
      showPrevNextButtons={false}
      setCurrentPage={onPageChange}
      {...rest}
    />
  )
}

export default MMPagination
